import { render, staticRenderFns } from "./InterestingDetail.vue?vue&type=template&id=1ca107ff"
import script from "./InterestingDetail.vue?vue&type=script&lang=js"
export * from "./InterestingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports